import { render, staticRenderFns } from "./CompanyRequestList.vue?vue&type=template&id=bd5f23e6"
import script from "./CompanyRequestList.vue?vue&type=script&lang=js"
export * from "./CompanyRequestList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports